module.exports = __webpack_public_path__ + "img/logout.05e3ebed.svg";